export default [
  {
    name: 'ActivityTypesCompaniesList',
    path: 'settings/companies/activity-types',
    component: () => import('pages/settings/activity-types/ActivityTypesCompaniesList.vue')
  },
  {
    name: 'ActivityTypesList',
    path: 'settings/companies/:id/activity-types',
    component: () => import('pages/settings/activity-types/ActivityTypesList.vue')
  },
  {
    name: 'ActivityTypesCreate',
    path: 'settings/companies/:id/activity-types/new',
    component: () => import('pages/settings/activity-types/ActivityTypesForm.vue')
  },
  {
    name: 'ActivityTypesEdit',
    path: 'settings/companies/:id/activity-types/:activityId/edit',
    component: () => import('pages/settings/activity-types/ActivityTypesForm.vue')
  }
]
